<div class="popup" *ngIf="isVisibleDetails">
    <div class="container-detalles panelDetailLocations" [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches && !isLoading)}">
      <loading [isLoading]="isLoading"></loading>
  
      <div *ngIf="!mobileQuery.matches" class="btnClose">
        <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false" aria-label="Example home icon" fontIcon="cancel" (click)="CancelButton()"></mat-icon>
      </div>

      <div *ngIf="!mobileQuery.matches" class="arrow-container">
          <mat-icon *ngIf="!fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_up</mat-icon>
          <mat-icon *ngIf="fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_down</mat-icon>
      </div>
      <div class="details-flex car-details-flex">
  
        <!-- Primera sección -->
        <div class="header_panel">

          <div class="btnReturn" (click)="CancelButton()" matTooltip="Regresar">
            <mat-icon>arrow_back_ios</mat-icon>
          </div>
  
            <!-- Encabezado -->
            <div *ngIf="images.length == 0" class="header-background" [ngClass]="{'col-3': !mobileQuery.matches}">
                <img [src]="locationDTO.panelIcon | findUrl" class="header-img" />

                <!-- VIN-->
                <div class="row header-text" [ngClass]="{'col-9': !mobileQuery.matches}">
                    <label class="subtitlePanel" [matTooltip]="this.locationDTO.description"> {{this.locationDTO.description | slice:0:50}}</label>

                    <label class="vin-title-container"> 
                      <div class="vin-title">
                        {{ this.locationDTO.identifier }}
                      </div>
                    </label>
                    
                </div>

                <div class="tool-opener" *ngIf="mobileQuery.matches || fullScreen" (click)="toggleToolButton()">
                  <img *ngIf="!isToolButtonPressed" [src]="'menu_hamburguesa.svg' | findUrl">
                  <img *ngIf="isToolButtonPressed" [src]="'boton_menos_contraer_menu.svg' | findUrl">
                </div>
            </div>

            <!-- carrusel -->
            <div *ngIf="images.length > 0 && mobileQuery.matches" class="header-carousel" [ngClass]="{'col-3': !mobileQuery.matches}">
              <carousel [images]="images"></carousel>
            </div>

        </div>

        <!-- seccion de herramientas -->
        <div [@mostrarHerramientas]="isToolButtonPressed?'visible':'hidden'" class="button-tool-list-vertical details-tool-list-for-tutorial">
              <location-button-toolbar *ngIf="!isLoading" 
                [identifier]="locationDTO.identifier"
                [description]="locationDTO.description"
                [description]="locationDTO.description"
                [isDetailLocations]="true" 
                [hasValetParking] = "true"
                [isValetParking]="valetParkingMapService.existValetParking" 
                [blockingObject]="blockingObject" 
                [valetParkingGuid]="valetParkingGuid" 
                [isLoadingParent]="isLoading"
                [isMonitor]="mobileQuery.matches"
                [images]="images"
                [isReloadable]="true"
                [CordX]="locationDTO.cordsX"
                [CordY]="locationDTO.cordsY"
                [isVerticalList]="true"
                (valetParkingDeleteResponse)="DeleteValetParking($event)"
                (valetParkingCreateResponse)="CreateValetParking()">
              </location-button-toolbar>
              
              <app-report-list [identifier]="locationDTO.identifier"
                [description]="locationDTO.description" 
                              [isDetailLocations]="true"
                              [isVerticalList]="true"></app-report-list>
          </div>

        <!-- seccion de ttabs -->
        <div class="tab-group">
          <mat-tab-group class="details-tab-group">
            <mat-tab>
              <ng-template mat-tab-label >
                <label  matTooltip="Resumen del Activo" matTooltipPosition="above">
                <mat-icon class="example-tab-icon">info</mat-icon>
                 Detalle Activo </label>
              </ng-template>
              <ng-template matTabContent >
                <div class="tab-content-wrapper">
                  <!-- primera sección -->
                  <div class="main-data-section-container">

                    <div class="row-image-data">
                      <div class="title-img-container">
                        <!-- <label class="titlePanel">Dirección</label> -->
                        <img class="title-img" [src]="(EnumDetailIconNames.Autos | detailsIcons:EnumCarDetailProperties.Direccion:EnumCarDetailProperties.Valor_unico) | findUrl">
                      </div>
                      <div class="">
                        <div *ngIf="this.Address" class="general-data">{{ this.Address }}</div>
                        <div *ngIf="!this.Address" class="general-data">N/A</div>
                      </div>
                    </div>
                    
                      <div class="image-data">
                        <div class="title-img-container" matTooltip="Estado de Actualización" matTooltipPosition="above">
                          <!-- <label class="titlePanel">Estado de Actualización:</label> -->
                          <img class="title-img" [src]="(EnumDetailIconNames.Autos | detailsIcons:EnumCarDetailProperties.EstadoActualizacion:locationDTO.categoryStatus) | findUrl">
                        </div>
                        <div class="">
                          <div class="general-data">{{ this.locationDTO.categoryStatus || 'N/A' }}</div>
                        </div>
                      </div>

                      <div class="image-data">
                        <div class="title-img-container" matTooltip="Estado del Vehiculo" matTooltipPosition="above">
                          <!-- <label class="titlePanel">Estado del Vehiculo:</label> -->
                          <img class="title-img" [src]="(EnumDetailIconNames.Autos | detailsIcons:EnumCarDetailProperties.EstadoVehiculo:locationDTO.statusVehiculo) | findUrl">
                        </div>
                        <div class="">
                          <div class="general-data">{{ this.locationDTO.statusVehiculo || 'N/A' }}</div>
                        </div>
                      </div>

                      <div class="image-data">
                        <div class="title-img-container" matTooltip="Última Actualización" matTooltipPosition="above">
                          <!-- <label class="titlePanel">Ult. Act:</label> -->
                          <img class="title-img" [src]="(EnumDetailIconNames.Autos | detailsIcons:EnumCarDetailProperties.UltimaActualizacion:EnumCarDetailProperties.Valor_unico) | findUrl">
                        </div>
                        <div class="general-data">
                          <span *ngIf="this.locationDTO.lastUpdate"> {{ this.locationDTO.lastUpdate }}</span>
                          <span *ngIf="!this.locationDTO.lastUpdate"> N/A</span>
                        </div>
                      </div>
                      
                      <div class="image-data">
                        <div class="title-img-container" matTooltip="Coordenadas" matTooltipPosition="above">
                          <!-- <label class="titlePanel">Coordenadas</label> -->
                          <img class="title-img" [src]="(EnumDetailIconNames.Autos | detailsIcons:EnumCarDetailProperties.Coordenadas:EnumCarDetailProperties.Valor_unico) | findUrl">
                        </div>
                        <div class="">
                          <div class="general-data">{{ this.Coords || 'N/A' }}</div>
                        </div>
                      </div>
      
                      <div class="image-data">
                        <div class="title-img-container" matTooltip="Bloqueo" matTooltipPosition="above">
                          <!-- <label class="titlePanel">Bloqueo</label> -->
                          <img class="title-img" [src]="(EnumDetailIconNames.Autos | detailsIcons:EnumCarDetailProperties.Bloqueo:locationDTO.canLock) | findUrl"> 
                        </div>
                        <div class="">
                          <div class="general-data">{{ this.locationDTO.canLock || 'N/A' }}</div>
                        </div>
                      </div>
      
                      <div class="image-data" *ngIf="!!this.locationDTO.subGroup" matTooltip="Subcuenta">
                        <div class="title-img-container">
                          <!-- <label class="titlePanel">Subcuenta</label> -->
                          <img class="title-img" [src]="(EnumDetailIconNames.Autos | detailsIcons:EnumCarDetailProperties.Subcuenta:EnumCarDetailProperties.Valor_unico) | findUrl">
                        </div>
                        <div class="">
                          <div class="general-data">{{ this.locationDTO.subGroup.name || 'N/A' }}</div>
                        </div>
                      </div>


                      <!-- kilometraje para editar -->
                      <div class="image-data" *ngIf="('VerOdometro-L' | permissionFilter) && ('EditarOdometro-L' | permissionFilter)" matTooltip="Editar kilometraje">
                        <div class="title-img-container input-data" (click)="openOdometerSwal()">
                          <img class="title-img" [src]="(EnumDetailIconNames.Autos | detailsIcons:EnumCarDetailProperties.Odometro:EnumCarDetailProperties.Valor_unico) | findUrl">
                        </div>
                        <div class="">
                          <div class="general-data">{{ odometroFinalLocation }} km</div>
                        </div>
                      </div>

                      <!-- kilometraje para sólo leer -->
                      <div class="image-data" *ngIf="('VerOdometro-L' | permissionFilter) && !('EditarOdometro-L' | permissionFilter)" matTooltip="Kilometraje">
                        <div class="title-img-container">
                          <img class="title-img" [src]="(EnumDetailIconNames.Autos | detailsIcons:EnumCarDetailProperties.Odometro:EnumCarDetailProperties.Valor_unico) | findUrl">
                        </div>
                        <div class="">
                          <div class="general-data">{{ odometroFinalLocation }} km</div>
                        </div>
                      </div>

                      <div *ngIf=" ('VerAlias-L' | permissionFilter) && ('EditarAlias-L' | permissionFilter)" class="image-data" matTooltip="Editar alias">
                        <div class="title-img-container input-data" (click)="openAliasSwal()">
                          <!-- <label class="titlePanel">Subcuenta</label> -->
                          <img class="title-img" [src]="(EnumDetailIconNames.Autos | detailsIcons:EnumCarDetailProperties.Alias:EnumCarDetailProperties.Valor_unico) | findUrl">
                        </div>
                        <div class="">
                          <div class="general-data">{{ locationDTO.alias || 'N/A' }}</div>
                        </div>
                      </div>

                      <div *ngIf="('VerAlias-L' | permissionFilter) && !('EditarAlias-L' | permissionFilter)" class="image-data" matTooltip="Alias">
                        <div class="title-img-container">
                          <!-- <label class="titlePanel">Subcuenta</label> -->
                          <img class="title-img" [src]="(EnumDetailIconNames.Autos | detailsIcons:EnumCarDetailProperties.Alias:EnumCarDetailProperties.Valor_unico) | findUrl">
                        </div>
                        <div class="">
                          <div class="general-data">{{ locationDTO.alias || 'N/A' }}</div>
                        </div>
                      </div>
                    
                  </div>
                    
    
                  <div class="data-section-container">
                    <div class="text-header">
                      <h3>Datos del Activo</h3>
                    </div>
    
                    <div *ngFor="let key of detallesActivo; let i = index" >
                        <!-- [ngClass]="{'background-shade': (i % 2 == 0)}" -->
                      <div *ngIf="getNameVisibility(key)" class="row-data">
                        <div class="">
                          <label class="titlePanel">{{ getUsableName(key) }}</label>
                        </div>
                        <div class="general-data">
                          <div>{{ Values[Keys.indexOf(key)] || 'N/A' }}</div>
                        </div>
                      </div>  
                    </div>
    
                  </div>
    
                  <div class="data-section-container">
                    <div class="text-header">
                      <h3>Datos del GPS</h3>
                    </div>
            
                    <div *ngIf="getNameVisibility('Estado del GPS')" class="row-data">
                      <div class="">
                        <label class="titlePanel">{{ getUsableName('Estado del GPS') }}</label>
                      </div>
                      <div class="general-data">
                        <div>{{ locationDTO.gpsStatus || 'N/A' }}</div>
                      </div>
                    </div>
            
                    <div *ngFor="let key of detallesGPS; let i = index" >
                       <!-- [ngClass]="{'background-shade': (i % 2 != 0)}" -->
                      <div *ngIf="getNameVisibility(key)" class="row-data">
                        <div class="">
                          <label class="titlePanel">{{ getUsableName(key) }}</label>
                        </div>
                        <div class="general-data">
                          <div>{{ Values[Keys.indexOf(key)] || 'N/A' }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="row-data">
                      <div class="">
                        <label class="titlePanel">Voltaje De Bateria</label>
                      </div>
                      <div class="">
                        <div *ngIf="this.locationDTO.lastVoltaje" class="general-data">{{ this.locationDTO.lastVoltaje }}<span *ngIf="this.locationDTO.lastVoltaje != 'N/A'">V</span> </div>
                        <div *ngIf="!this.locationDTO.lastVoltaje" class="general-data">N/A</div>
                      </div>
                    </div>
                    <div class="row-data">
                      <div class="">
                        <label class="titlePanel">Porcentaje De Bateria</label>
                      </div>
                      <div class="">
                        <div *ngIf="this.locationDTO.batteryPercent" class="general-data">{{ this.locationDTO.batteryPercent }}<span *ngIf="this.locationDTO.batteryPercent != 'N/A'">%</span></div>
                        <div *ngIf="!this.locationDTO.batteryPercent" class="general-data">N/A</div>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </ng-template>
            </mat-tab>

            <mat-tab *ngIf="hasRelatedData" [disabled]="this.isLoading" class="related">
              <ng-template mat-tab-label >
                <label  matTooltip="Activos Asociados" matTooltipPosition="above">
                <mat-icon class="example-tab-icon">info</mat-icon>
                Asociados </label>
              </ng-template>
              <ng-template matTabContent>
                <div class="tab-content-wrapper">
                  <div class="location-related" [ngClass]="{'container': mobileQuery.matches}">
                    <!-- primera seccion -->
                    <!-- servicios asociados -->
                    <!-- <location-related-list [identifier]="this.locationDTO.identifier" ></location-related-list> -->
                  </div>
                </div>
                  
              </ng-template>
            </mat-tab>
            
          </mat-tab-group>
        </div>
      </div>  
  
    </div>
  </div>